import axios from 'axios'
import router from '../router'
import store from "../store";
import {Message} from "element-ui";

const urlTop=window.location.protocol+"//"+window.location.host
const request = axios.create({
   // baseURL: 'https://api-sandbox.xiaoshouyi.com',
  //  baseURL: 'https://api-p05.xiaoshouyi.com',
  baseURL:urlTop,
    timeout: 60000, // 请求超时时间
   // withCredentials: true, // 默认false
})
request.interceptors.request.use(config => {
    let sess=sessionStorage.getItem('sess')?sessionStorage.getItem('sess'):''
    config.headers['session']=sess
    return config
}, error => {
    Promise.reject(error)
})
request.interceptors.response.use(
    response => {
        if(response.data.code=='1020008'){
            Message.error('token过期，请重新登录')
            router.push('/login')
        }
        // if (response.status != 200) {
        //     Message.info({
        //         title: '提示',
        //         content: '登录过期',
        //         okText: '重新登录',
        //         onOk: () => {
        //             localStorage.clear()
        //             router.push('/login');
        //         }
        //     })
        // }
        // if(!response.data.success){
        //     if(response.data.code){
        //         if(response.data.code === -2){
        //             Message.warning(response.data.msg);
        //         }
        //         else if(response.data.code === -1){
        //             this.$message.info({
        //                 title: '提示',
        //                 content: response.data.msg,
        //                 okText: '重新登录',
        //                 onOk: () => {
        //                     localStorage.clear()
        //                     Message.success('退出成功！');
        //                     router.push( '/login' );
        //                 }
        //             })
        //         }
        //     }
        // }
        return response
    },
    error => {
        Message.error(error);
      //  router.push('/login')
        return Promise.reject(error)
    })

export default request

